import { FormView, PresetId } from '@account/account-portal/config'
import { useABTest } from '@crystal/ab-testing'
import { useEffect, useState } from 'react'

import { ABTests, LoginABTests } from '../ab-tests'

import { ViewData } from './'

export function useHydration() {
  const [isHydrated, setIsHydrated] = useState(false)

  useEffect(() => {
    setIsHydrated(true)
  }, [])

  return {
    isHydrated,
  }
}

export const useIsOneStepView = (viewData: ViewData) => {
  const abTestVariant = useABTest(ABTests.FORM_STEPS)
  const isABTestVariant = abTestVariant === '2'

  return getIsOneStepView(isABTestVariant, viewData.preset, viewData.formView)
}

export function getIsOneStepView(isABTestVariant: boolean, preset?: PresetId, formView?: FormView) {
  // If config sets the form to one step, it cannot be 2steps, but the other way around is possible.
  // If preset is login-method, it cannot be 1 step because this preset requires 2 steps.
  return preset !== 'login-method' && preset !== 'checkout-inline' && (formView === FormView.OneStep || isABTestVariant)
}

export const useEmphasizedSocialLoginView = () => {
  return useABTest(LoginABTests.FORM_VIEW)
}
